import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectAuthToken } from "redux/features/auth";
import optionsSlice from "redux/features/optionData";
import EnhancedSelect from "components/enhancedSelect";
import Loading from "util/loading";
import ErrorMessage from "util/errorMessage";

import { Navigate } from "react-router-dom";
import { Container } from "react-bulma-components";
import TopBar from "components/topbar";

import { useRawSetTitle } from "util/title";
import { usePortalContext } from "context";

const personListLoadConfig = {
  url: "/people",
  selectAuthToken,
  optionConfig: {
    labelField: "full_name",
    valueField: "id",
    aliases: [
      ["email_addresses", "email address"],
      [
        (item) => [item.last_name + ", " + item.first_name],
        "last_name, first_name",
      ],
      [
        (item) => [
          item.first_name.substring(0, item.first_name.indexOf(" ")) +
            " " +
            item.last_name,
        ],
        "first_part_of_first_name last_name",
      ],
    ],
    labelExtras: [
      (item) => (
        <Fragment>
          <i>affil:</i>{" "}
          {item.institution_names.length > 0 ? (
            item.institution_names.join(", ")
          ) : (
            <i>none</i>
          )}
        </Fragment>
      ),
      (item) => (
        <Fragment>
          <i>email:</i>{" "}
          {item.email_addresses.length > 0 ? (
            item.email_addresses.join(", ")
          ) : (
            <i>none</i>
          )}
        </Fragment>
      ),

      (item) => item.activity_titles,
    ],
  },
};

export function PersonSelectionPage(props) {
  const {
    selector,
    asyncActions: { loader, reload },
  } = optionsSlice("people");
  const personOptions = useSelector(selector);

  const dispatch = useDispatch();
  const uninitialized = personOptions.loaded === null || personOptions.failed;
  useEffect(() => {
    if (uninitialized) {
      dispatch(loader(personListLoadConfig));
    }
    const timerId = window.setInterval(() => dispatch(reload()), 60000);
    return () => window.clearInterval(timerId);
  }, [uninitialized, dispatch, loader, reload]);

  const [selection, setSelection] = useState(null);
  useRawSetTitle("Profile Lookup");
  const { staffUsername } = usePortalContext();

  return (
    <Fragment>
      <TopBar staffUsername={staffUsername} />

      <Container className="spaced">
        {selection && selection.value ? (
          <Navigate to={"for/" + selection.value} replace />
        ) : personOptions.failed ? (
          <ErrorMessage>
            Failed loading list of people: {personOptions.failed.message}
          </ErrorMessage>
        ) : !personOptions.loaded ? (
          <Fragment>
            Loading list of people from database... <Loading />
          </Fragment>
        ) : (
          <Fragment>
            <p className="select-person">
              Please select which person's profile you wish to edit:
            </p>
            <EnhancedSelect
              datasetName="people"
              loadConfig={personListLoadConfig}
              minCharacters={1}
              creatable={false}
              selection={selection}
              setSelection={setSelection}
            />
          </Fragment>
        )}
      </Container>
    </Fragment>
  );
}
